import { Button, ResourceTile, ResourceTileGrid, StatusMessage } from '@krp/ui-kit'
import { pointSourceNames, problemText, registersText, type SalesPointProblem } from '../model/format'
import type { SalesPointDirectory } from '../model/types'
import './sales-points.css'

export interface SalesPointsProps {
  directory: SalesPointDirectory | undefined
  loading: boolean
  error: SalesPointProblem | null
  /** Создавать магазины может только администратор приложения (`system_admin`): остальным кнопки нет вовсе. */
  canCreate: boolean
  create: () => void
  open: (id: string) => void
  reload: () => void
}

/** Список магазинов касс плитками: вход в статистику группы. Группа в архиве в списке не показывается; «Создать магазин» — тихо внизу и только администратору. */
export function SalesPointsScreen(props: SalesPointsProps) {
  const points = (props.directory?.points ?? []).filter((point) => !point.archived)
  return <section className="sales-points" aria-label="Магазины">
    {props.error !== null && <StatusMessage kind="error" title="Не удалось получить магазины" text={problemText(props.error)} />}
    {props.loading && props.directory === undefined && <p role="status">Загружаем магазины…</p>}
    {props.directory !== undefined && (points.length === 0
      ? <p className="sales-points__empty" role="status">Магазинов пока нет.</p>
      : <ResourceTileGrid label="Магазины">
        {points.map((point) => <ResourceTile key={point.id} mark="МГ" noun="Магазин" name={point.name} ariaLabel={`Магазин ${point.name}`}
          lines={[registersText(point.registers.length), ...pointSourceNames(point)]}
          footer={<Button variant="primary" actionId="receipts.sales-points.open" aria-label={`Открыть магазин ${point.name}`} onClick={() => props.open(point.id)}>Открыть</Button>} />)}
      </ResourceTileGrid>)}
    <div className="sales-points__foot">
      <Button variant="ghost" actionId="receipts.sales-points.reload" busy={props.loading} onClick={props.reload}>Обновить</Button>
      {props.canCreate && <Button variant="ghost" data-size="sm" actionId="receipts.sales-points.create" onClick={props.create}>Создать магазин</Button>}
    </div>
  </section>
}
